module.exports = __webpack_public_path__ + "img/logo_xxh_noborder.a5999a2c.png";